import { render, staticRenderFns } from "./approvalEdit.vue?vue&type=template&id=2e8e9fff&scoped=true&"
import script from "./approvalEdit.vue?vue&type=script&lang=js&"
export * from "./approvalEdit.vue?vue&type=script&lang=js&"
import style0 from "./approvalEdit.vue?vue&type=style&index=0&id=2e8e9fff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e8e9fff",
  null
  
)

component.options.__file = "approvalEdit.vue"
export default component.exports